import type { Campaign } from './campaigns';
import type { ProductDownload } from './productDownloads';
import type { PageMetaKey } from './pageMeta';
import { FALLBACK_CAMPAIGNS } from './campaigns';
import { PRODUCT_DOWNLOADS } from './productDownloads';
import { BRAND } from './brand';

export type SeoPageOverride = {
  title?: string;
  description?: string;
  keywords?: string;
};

export type SiteSeoConfig = {
  globalKeywords?: string;
  pages?: Partial<Record<PageMetaKey, { tr?: SeoPageOverride; en?: SeoPageOverride }>>;
};

export type SiteContact = {
  email: string;
  phone: string;
  address: string;
  mapUrl: string;
};

export type SiteAnnouncement = {
  id: string;
  enabled: boolean;
  message: string;
  ctaLabel: string;
  link: string;
  startDate?: string;
  endDate?: string;
};

export type SiteIntegrations = {
  chatEnabled: boolean;
  gaMeasurementId: string;
};

export type NavbarLinks = {
  supportUrl?: string;
};

export const DEFAULT_SUPPORT_BUTTON_URL = 'https://luminarybs.com/support/';

export type SiteConfig = {
  version: number;
  contact: SiteContact;
  campaigns: Campaign[];
  announcements: SiteAnnouncement[];
  downloads: ProductDownload[];
  integrations: SiteIntegrations;
  seo?: SiteSeoConfig;
  navbarLinks?: NavbarLinks;
};

export function getSupportPortalUrl(site?: SiteConfig): string {
  return site?.navbarLinks?.supportUrl?.trim() || DEFAULT_SUPPORT_BUTTON_URL;
}

export const DEFAULT_SITE_CONFIG: SiteConfig = {
  version: 1,
  contact: {
    email: BRAND.email,
    phone: '+90 212 000 00 00',
    address:
      'Bahçeşehir 2. Kısım Mah. Nezih Barut Cad. Spradon Residence No: 9/101, 34488 Başakşehir — İstanbul',
    mapUrl: 'https://maps.google.com/?q=Başakşehir+İstanbul',
  },
  campaigns: FALLBACK_CAMPAIGNS,
  announcements: [],
  downloads: PRODUCT_DOWNLOADS,
  integrations: {
    chatEnabled: true,
    gaMeasurementId: '',
  },
  seo: {},
  navbarLinks: {
    supportUrl: DEFAULT_SUPPORT_BUTTON_URL,
  },
};

export function getActiveAnnouncement(announcements: SiteAnnouncement[]): SiteAnnouncement | null {
  const now = new Date();
  for (const item of announcements) {
    if (!item.enabled || !item.message.trim()) continue;
    if (item.startDate && new Date(item.startDate) > now) continue;
    if (item.endDate && new Date(item.endDate) < now) continue;
    return item;
  }
  return null;
}

export const SITE_PUBLIC_JSON_URL = `${import.meta.env.BASE_URL}site-public.json`;
export const SITE_CONFIG_API_URL = `${import.meta.env.BASE_URL}api/public-config.php`;

export type AdminSecretsView = {
  geminiApiKey: string;
  geminiModel: string;
  web3formsAccessKey: string;
  formSubmitEmail: string;
  hasGeminiApiKey: boolean;
  hasWeb3formsAccessKey: boolean;
};

export type AdminSecretsInput = {
  geminiApiKey?: string;
  geminiModel?: string;
  web3formsAccessKey?: string;
  formSubmitEmail?: string;
};
